import React from "react";
import { createRoot } from "react-dom/client";
import App from "./App";
import { GoogleOAuthProvider } from "@react-oauth/google";
import "./i18n"; // Initialize i18n

// Redirect root-only visits on joinblockclub.com → blockclubevents.com.
// Runs before React mounts so no hooks are involved and no flash occurs.
// Any path with a suffix (e.g. /events/...) loads normally.
const { hostname, pathname } = window.location;
if (
  (hostname === 'joinblockclub.com' || hostname === 'www.joinblockclub.com') &&
  pathname === '/'
) {
  window.location.replace('https://www.blockclubevents.com');
}

// Reset zoom level on page load
window.addEventListener("load", () => {
  document.body.style.zoom = "1";
});

// Get the root container element
const container = document.getElementById("root");

// Create the React root
const root = createRoot(container);

root.render(
  <React.StrictMode>
    <GoogleOAuthProvider clientId={process.env.REACT_APP_GOOGLE_CLIENT_ID}>
      <App />
    </GoogleOAuthProvider>
  </React.StrictMode>
);
